import { formatCurrency } from "./format"
import { useSponsorPortal } from "./sponsor-session-context"
import { DonorEmptyState } from "./components/empty-state"
import { SponsorshipStatusCard } from "./components/sponsorship-status"

export function DonorGivingPage() {
  const portal = useSponsorPortal()
  if (!portal) return null

  const donations = portal.donations
  const year = new Date().getFullYear()
  const totalGiven = donations
    .filter((donation) => donation.status === "completed" && new Date(donation.donatedAt).getFullYear() === year)
    .reduce((total, donation) => total + donation.amount, 0)

  return (
    <div className="donor-giving">
      <div className="donor-giving__header">
        <div>
          <h1>Giving history</h1>
          <p>Every contribution and receipt in one place.</p>
        </div>
        <p className="donor-giving__total">
          Total given in {year}: <strong>{formatCurrency(totalGiven)}</strong>
        </p>
      </div>

      {donations.length === 0 && portal.sponsorshipRequest ? (
        <SponsorshipStatusCard
          request={portal.sponsorshipRequest}
          matchState={portal.matchState}
          activeMatchCount={portal.activeMatchCount}
        />
      ) : donations.length === 0 ? (
        <DonorEmptyState
          title={portal.sponsorshipRequest ? "Your sponsorship request is being reviewed" : "Your giving history will appear here"}
          description={portal.sponsorshipRequest
            ? "Your request status is available in the sponsorship request page. Giving history will appear here after your first contribution."
            : "Processed contributions, payment status, and receipt references will be added here automatically after your first contribution."
          }
          primaryLabel={portal.sponsorshipRequest ? "View sponsorship status" : "Start a sponsorship"}
          primaryTo={portal.sponsorshipRequest ? "/donor/request" : "/sponsor"}
          secondaryLabel="Contact Redempta"
          secondaryTo="/contact"
        />
      ) : (
      <>
      <div className="donor-giving__table-wrapper">
        <table className="donor-giving__table">
          <thead>
            <tr>
              <th>Date</th>
              <th>Amount</th>
              <th>Type</th>
              <th>Child</th>
              <th>Status</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {donations.map((donation) => (
              <tr key={donation.id}>
                <td>{new Date(donation.donatedAt).toLocaleDateString()}</td>
                <td>{formatCurrency(donation.amount)}</td>
                <td>{donation.designation.replaceAll("_", " ")}</td>
                <td>{donation.childName ?? "General"}</td>
                <td>
                  <span className={`donor-giving__status donor-giving__status--${donation.status}`}>
                    {donation.status.charAt(0).toUpperCase() + donation.status.slice(1)}
                  </span>
                </td>
                <td><span className="donor-giving__receipt">{donation.receiptCode}</span></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <ul className="donor-giving__cards">
        {donations.map((donation) => (
          <li key={donation.id} className="donor-giving__card">
            <div className="donor-giving__card-top">
              <span className="donor-giving__card-amount">{formatCurrency(donation.amount)}</span>
              <span className={`donor-giving__status donor-giving__status--${donation.status}`}>
                {donation.status.charAt(0).toUpperCase() + donation.status.slice(1)}
              </span>
            </div>
            <p className="donor-giving__card-meta">
              {new Date(donation.donatedAt).toLocaleDateString()} · {donation.designation.replaceAll("_", " ")} · {donation.childName ?? "General"}
            </p>
            <p className="donor-giving__card-receipt">{donation.receiptCode}</p>
          </li>
        ))}
      </ul>
      </>
      )}
    </div>
  )
}
